var _symbol, _symbol2, _symbol3, _symbol4, _symbol5, _symbol6, _symbol7, _symbol8, _symbol9, _symbol10, _symbol11, _symbol12, _symbol13, _symbol14, _symbol15, _symbol16, _symbol17, _symbol18, _symbol19, _symbol20;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAllSvgFinTrack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    style: {
      position: "absolute",
      width: 0,
      height: 0,
      overflow: "hidden"
    },
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("symbol", {
    id: "icon-education",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ff7601",
    style: {
      fill: "var(--color1, #ff7601)"
    },
    d: "M18.827 2.169c-0.842-0.545-1.824-0.835-2.827-0.835s-1.985 0.29-2.827 0.835l-13.173 8.497 5.333 3.44v13.112l0.391 0.391c0.125 0.124 3.139 3.057 10.276 3.057s10.151-2.933 10.276-3.057l0.391-0.391v-13.112l2.667-1.72v14.28h2.667v-16l-13.173-8.497zM24 26.021c-2.41 1.443-5.196 2.132-8 1.979-2.804 0.154-5.59-0.535-8-1.977v-10.196l5.173 3.333c0.841 0.547 1.823 0.837 2.827 0.837s1.985-0.291 2.827-0.837l5.173-3.333v10.195zM17.381 16.922c-0.411 0.267-0.891 0.41-1.381 0.41s-0.97-0.142-1.381-0.41l-9.699-6.256 9.699-6.256c0.411-0.267 0.891-0.41 1.381-0.41s0.97 0.142 1.381 0.41l9.699 6.256-9.699 6.256z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-entertainment",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ff7601",
    style: {
      fill: "var(--color1, #ff7601)"
    },
    d: "M27.2 4h-22.4l-0.4 0.4c-2.8 3.2-4.4 7.333-4.4 11.6 0 7.333 2.933 13.333 6.667 13.333 2.933 0 4.4-4.267 5.067-6.667h8.533c0.667 2.4 2.133 6.667 5.067 6.667 3.733 0 6.667-6 6.667-13.333 0-4.267-1.6-8.4-4.4-11.6l-0.4-0.4zM25.333 26.667c-0.8 0-2.133-2.8-2.667-5.6l-0.267-1.067h-12.8l-0.267 1.067c-0.533 2.8-1.867 5.6-2.667 5.6-1.333 0-4-4.133-4-10.667 0-3.333 1.2-6.667 3.333-9.333h20.133c2.133 2.667 3.2 6 3.2 9.333 0 6.533-2.667 10.667-4 10.667z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff7601",
    style: {
      fill: "var(--color1, #ff7601)"
    },
    d: "M10.667 9.334h-2.667v2.667h-2.667v2.667h2.667v2.667h2.667v-2.667h2.667v-2.667h-2.667v-2.667z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff7601",
    style: {
      fill: "var(--color1, #ff7601)"
    },
    d: "M24.666 13.334c1.105 0 2-0.895 2-2s-0.895-2-2-2c-1.105 0-2 0.895-2 2s0.895 2 2 2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff7601",
    style: {
      fill: "var(--color1, #ff7601)"
    },
    d: "M20.666 17.334c1.105 0 2-0.895 2-2s-0.895-2-2-2-2 0.895-2 2c0 1.105 0.895 2 2 2z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-exit",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ff7601",
    style: {
      fill: "var(--color1, #ff7601)"
    },
    d: "M2.667 28v-24c0-0.354 0.14-0.693 0.391-0.943s0.589-0.391 0.943-0.391h6.667v-2.667h-6.667c-1.061 0-2.078 0.421-2.828 1.172s-1.172 1.768-1.172 2.828v24c0 1.061 0.421 2.078 1.172 2.828s1.768 1.172 2.828 1.172h6.667v-2.667h-6.667c-0.354 0-0.693-0.141-0.943-0.391s-0.391-0.589-0.391-0.943z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff7601",
    style: {
      fill: "var(--color1, #ff7601)"
    },
    d: "M30.83 13.171l-6.115-6.115-1.885 1.885 5.685 5.685-21.849 0.039v2.667l21.924-0.039-5.763 5.763 1.885 1.885 6.115-6.115c0.75-0.75 1.172-1.767 1.173-2.827s-0.42-2.078-1.17-2.829z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-eye",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ff7601",
    style: {
      fill: "var(--color1, #ff7601)"
    },
    d: "M31.761 14.908c-1.171-2.56-5.761-10.908-15.761-10.908s-14.591 8.348-15.761 10.908c-0.157 0.343-0.238 0.716-0.238 1.093s0.081 0.75 0.238 1.093c1.171 2.557 5.761 10.905 15.761 10.905s14.591-8.348 15.761-10.908c0.157-0.343 0.238-0.715 0.238-1.092s-0.081-0.749-0.238-1.092zM16 25.333c-8.409 0-12.333-7.155-13.333-9.319 1-2.193 4.924-9.348 13.333-9.348 8.389 0 12.315 7.124 13.333 9.333-1.019 2.209-4.944 9.333-13.333 9.333z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff7601",
    style: {
      fill: "var(--color1, #ff7601)"
    },
    d: "M16 9.334c-1.319 0-2.607 0.391-3.704 1.124s-1.951 1.774-2.455 2.992c-0.505 1.218-0.637 2.559-0.379 3.852s0.892 2.481 1.825 3.413c0.932 0.932 2.12 1.567 3.414 1.825s2.634 0.125 3.852-0.379c1.218-0.505 2.259-1.359 2.992-2.455s1.123-2.385 1.123-3.704c-0.002-1.767-0.705-3.462-1.955-4.712s-2.944-1.953-4.712-1.955zM16 20c-0.791 0-1.565-0.235-2.222-0.674s-1.171-1.064-1.473-1.795-0.382-1.535-0.228-2.311c0.154-0.776 0.535-1.489 1.095-2.048s1.272-0.94 2.048-1.095c0.776-0.154 1.58-0.075 2.311 0.228s1.356 0.815 1.795 1.473c0.44 0.658 0.674 1.431 0.674 2.222 0 1.061-0.421 2.078-1.172 2.828s-1.767 1.171-2.828 1.171z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-eye-crossed",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ff7601",
    style: {
      fill: "var(--color1, #ff7601)"
    },
    d: "M31.761 14.908c-1.288-2.794-3.175-5.27-5.527-7.253l4.043-4.043-1.887-1.888-4.391 4.387c-2.43-1.406-5.193-2.135-8-2.111-10 0-14.591 8.348-15.761 10.908-0.157 0.343-0.238 0.716-0.238 1.093s0.081 0.75 0.238 1.093c1.288 2.794 3.175 5.27 5.527 7.253l-4.041 4.043 1.885 1.885 4.391-4.387c2.43 1.406 5.193 2.135 8 2.111 10 0 14.591-8.348 15.761-10.908 0.157-0.343 0.238-0.715 0.238-1.092s-0.081-0.749-0.238-1.092zM2.667 16.015c1-2.193 4.924-9.348 13.333-9.348 2.093-0.012 4.158 0.476 6.024 1.424l-2.353 2.353c-1.28-0.85-2.815-1.231-4.344-1.078s-2.958 0.83-4.044 1.916c-1.086 1.086-1.764 2.515-1.916 4.044s0.228 3.064 1.078 4.344l-2.772 2.772c-2.133-1.737-3.844-3.935-5.005-6.428zM20 16c0 1.061-0.421 2.078-1.172 2.828s-1.768 1.172-2.828 1.172c-0.594-0.002-1.18-0.139-1.713-0.4l5.313-5.313c0.261 0.534 0.398 1.119 0.4 1.713zM12 16c0-1.061 0.421-2.078 1.172-2.828s1.768-1.172 2.828-1.172c0.594 0.002 1.18 0.139 1.713 0.4l-5.313 5.313c-0.261-0.534-0.398-1.119-0.4-1.713zM16 25.333c-2.093 0.012-4.158-0.476-6.024-1.424l2.353-2.353c1.28 0.85 2.815 1.231 4.344 1.078s2.958-0.83 4.044-1.916c1.086-1.087 1.764-2.515 1.916-4.044s-0.228-3.064-1.078-4.344l2.771-2.771c2.137 1.738 3.849 3.941 5.007 6.441-1.019 2.209-4.944 9.333-13.333 9.333z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-fashion",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ff7601",
    style: {
      fill: "var(--color1, #ff7601)"
    },
    d: "M1.202 28.506c-0.56 0-0.933-0.267-1.12-0.8s-0.053-0.986 0.4-1.36l14.318-11.239v-2.2c0-0.32 0.113-0.6 0.34-0.84s0.5-0.36 0.82-0.36c0.906 0.027 1.673-0.273 2.3-0.9s0.94-1.393 0.94-2.3c0-0.88-0.313-1.633-0.94-2.26s-1.38-0.94-2.26-0.94c-0.88 0-1.633 0.313-2.26 0.94s-0.94 1.38-0.94 2.26h-2.4c0-1.546 0.547-2.866 1.64-3.96s2.413-1.64 3.96-1.64c1.546 0 2.866 0.533 3.96 1.6s1.64 2.373 1.64 3.92c0 1.307-0.413 2.466-1.24 3.48s-1.88 1.707-3.16 2.080v1.12l14.319 11.239c0.453 0.373 0.586 0.827 0.4 1.36s-0.56 0.8-1.12 0.8h-29.597zM4.801 26.107h22.398l-11.199-8.919-11.199 8.919z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-gifts",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ff7601",
    style: {
      fill: "var(--color1, #ff7601)"
    },
    d: "M28 9.333h-4.179c0.924-0.843 1.656-1.874 2.147-3.024s0.729-2.392 0.698-3.643h-2.667c0 3.841-2.628 5.743-5.536 6.4 0.873-1.558 1.397-3.286 1.536-5.067 0-1.061-0.421-2.078-1.172-2.828s-1.768-1.172-2.828-1.172c-1.061 0-2.078 0.421-2.828 1.172s-1.172 1.768-1.172 2.828c0.139 1.78 0.663 3.509 1.536 5.067-2.908-0.657-5.536-2.559-5.536-6.4h-2.667c-0.031 1.25 0.207 2.492 0.698 3.643s1.223 2.181 2.147 3.024h-4.179c-1.061 0-2.078 0.421-2.828 1.172s-1.172 1.768-1.172 2.828v5.333h2.667v13.333h26.667v-13.333h2.667v-5.333c0-1.061-0.421-2.078-1.172-2.828s-1.768-1.172-2.828-1.172zM16 2.667c0.354 0 0.693 0.14 0.943 0.391s0.391 0.589 0.391 0.943c-0.161 1.417-0.615 2.785-1.333 4.017-0.718-1.232-1.172-2.6-1.333-4.017 0-0.354 0.141-0.693 0.391-0.943s0.589-0.391 0.943-0.391zM2.667 13.333c0-0.354 0.14-0.693 0.391-0.943s0.589-0.391 0.943-0.391h10.667v4h-12v-2.667zM5.333 18.667h9.333v10.667h-9.333v-10.667zM26.667 29.333h-9.333v-10.667h9.333v10.667zM29.333 16h-12v-4h10.667c0.354 0 0.693 0.14 0.943 0.391s0.391 0.589 0.391 0.943v2.667z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-greenCross",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#01ab3a",
    style: {
      fill: "var(--color2, #01ab3a)"
    },
    d: "M32 5.088l-18.256 18.272-6.784-6.784 2.256-2.256 4.528 4.528 16-16 2.256 2.24zM28.464 13.152c0.208 0.912 0.336 1.872 0.336 2.848 0 7.072-5.728 12.8-12.8 12.8s-12.8-5.728-12.8-12.8c0-7.072 5.728-12.8 12.8-12.8 2.528 0 4.864 0.736 6.848 2l2.304-2.304c-2.592-1.824-5.744-2.896-9.152-2.896-8.832 0-16 7.168-16 16s7.168 16 16 16c8.832 0 16-7.168 16-16 0-1.904-0.352-3.728-0.96-5.424l-2.576 2.576z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-groceries",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ff7601",
    style: {
      fill: "var(--color1, #ff7601)"
    },
    d: "M32 4h-26.344l-0.056-0.468c-0.115-0.973-0.582-1.87-1.314-2.521s-1.677-1.011-2.657-1.011h-1.629v2.667h1.629c0.327 0 0.642 0.12 0.886 0.337s0.4 0.516 0.438 0.84l2.113 17.957c0.115 0.973 0.582 1.87 1.314 2.521s1.677 1.011 2.657 1.011h17.629v-2.667h-17.629c-0.327-0-0.642-0.12-0.886-0.337s-0.4-0.517-0.438-0.841l-0.175-1.488h21.576l2.885-16zM26.885 17.333h-19.66l-1.255-10.667h22.839l-1.924 10.667z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff7601",
    style: {
      fill: "var(--color1, #ff7601)"
    },
    d: "M9.334 32.001c1.473 0 2.667-1.194 2.667-2.667s-1.194-2.667-2.667-2.667c-1.473 0-2.667 1.194-2.667 2.667s1.194 2.667 2.667 2.667z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff7601",
    style: {
      fill: "var(--color1, #ff7601)"
    },
    d: "M22.667 32.001c1.473 0 2.667-1.194 2.667-2.667s-1.194-2.667-2.667-2.667c-1.473 0-2.667 1.194-2.667 2.667s1.194 2.667 2.667 2.667z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-household",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ff7601",
    style: {
      fill: "var(--color1, #ff7601)"
    },
    d: "M25.287 9.952l6.705-6.705-1.905-1.905-6.728 6.727-2.941-2.875c-0.483-0.469-1.124-0.74-1.797-0.758s-1.328 0.218-1.835 0.66c-2.475 2.241-5.354 3.99-8.484 5.153l-8.309 2.436v1.008c0.055 4.551 1.912 8.894 5.164 12.077s7.634 4.947 12.185 4.904h1.655l0.348-0.243c2.719-1.743 4.974-4.119 6.573-6.924s2.494-5.957 2.608-9.184c0.010-0.372-0.057-0.741-0.197-1.086s-0.35-0.656-0.617-0.914l-2.424-2.372zM18.533 7.12l7.303 7.121c-0.040 1.36-0.244 2.709-0.608 4.020l-9.307-9.061c0.905-0.649 1.777-1.343 2.612-2.080v0zM18.141 27.98h-0.8c-1.965 0-3.91-0.389-5.724-1.145 2.33-1.171 4.325-2.914 5.797-5.067l0.691-1.013-2.225-1.515-0.691 1.015c-1.217 1.775-2.865 3.213-4.789 4.177l-1.639 0.824c-1.332-0.938-2.497-2.093-3.447-3.417 2.175-0.736 4.159-1.946 5.809-3.543l-1.881-1.927c-1.49 1.443-3.308 2.504-5.299 3.089-0.69-1.503-1.106-3.117-1.228-4.767l6.34-1.859c1.603-0.515 3.136-1.227 4.564-2.12l10.548 10.267c-1.395 2.798-3.465 5.204-6.024 7h-0.003z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-Interest",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ff7601",
    style: {
      fill: "var(--color1, #ff7601)"
    },
    d: "M2.667 32h12v-2.667h-10.115l27.448-27.448-1.885-1.885-27.448 27.448v-10.115h-2.667v12c0 0.707 0.281 1.385 0.781 1.886s1.178 0.781 1.886 0.781z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-internet",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ff7601",
    style: {
      fill: "var(--color1, #ff7601)"
    },
    d: "M16 0c-3.165 0-6.258 0.938-8.889 2.696s-4.682 4.257-5.893 7.181c-1.211 2.924-1.528 6.141-0.91 9.244s2.141 5.955 4.379 8.192c2.238 2.238 5.089 3.761 8.192 4.379s6.321 0.301 9.244-0.91c2.924-1.211 5.423-3.262 7.181-5.893s2.697-5.725 2.697-8.889c-0.005-4.242-1.692-8.309-4.691-11.309s-7.067-4.687-11.309-4.691v0zM27.529 9.333h-4.295c-0.961-2.228-2.227-4.312-3.761-6.192 3.395 0.924 6.29 3.149 8.056 6.192v0zM22 16c-0.011 1.357-0.225 2.706-0.635 4h-10.731c-0.41-1.294-0.624-2.643-0.635-4 0.011-1.357 0.225-2.706 0.635-4h10.731c0.41 1.294 0.624 2.643 0.635 4v0zM11.704 22.667h8.592c-1.132 2.234-2.578 4.294-4.296 6.117-1.718-1.822-3.165-3.883-4.296-6.117v0zM11.704 9.333c1.132-2.234 2.579-4.294 4.296-6.117 1.718 1.822 3.165 3.883 4.296 6.117h-8.592zM12.533 3.141c-1.536 1.88-2.805 3.964-3.768 6.192h-4.295c1.768-3.045 4.665-5.27 8.063-6.192v0zM3.281 12h4.585c-0.346 1.306-0.525 2.649-0.533 4 0.008 1.351 0.188 2.695 0.533 4h-4.585c-0.82-2.604-0.82-5.396 0-8v0zM4.471 22.667h4.295c0.963 2.228 2.232 4.312 3.768 6.192-3.398-0.922-6.295-3.147-8.063-6.192v0zM19.473 28.859c1.534-1.88 2.8-3.964 3.761-6.192h4.295c-1.766 3.043-4.661 5.268-8.056 6.192v0zM28.719 20h-4.585c0.346-1.305 0.525-2.649 0.533-4-0.009-1.351-0.188-2.694-0.533-4h4.583c0.82 2.604 0.82 5.396 0 8h0.003z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-medical",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ff7601",
    style: {
      fill: "var(--color1, #ff7601)"
    },
    d: "M21.333 32h-10.667v-10.667h-10.667v-10.667h10.667v-10.667h10.667v10.667h10.667v10.667h-10.667v10.667zM13.333 29.333h5.333v-10.667h10.667v-5.333h-10.667v-10.667h-5.333v10.667h-10.667v5.333h10.667v10.667z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-noCategory",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#ff751d",
    style: {
      stroke: "var(--color3, #ff751d)"
    },
    strokeLinejoin: "miter",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 3.6571,
    d: "M2.4 3.296v-0.006h0.006c1.104-0.098 2.211-0.168 3.319-0.21 2.67-0.106 5.839-0.091 8.192 0.26 0.148 0.029 0.282 0.104 0.384 0.214l14.179 14.177c0.085 0.085 0.153 0.186 0.199 0.297s0.070 0.23 0.070 0.35-0.024 0.239-0.070 0.35c-0.046 0.111-0.114 0.212-0.199 0.297l-10.344 10.342c-0.171 0.171-0.404 0.268-0.646 0.268s-0.475-0.096-0.646-0.268l-14.179-14.177c-0.11-0.102-0.185-0.236-0.214-0.384-0.351-2.353-0.366-5.522-0.26-8.192 0.051-1.32 0.134-2.485 0.21-3.319z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-paydayLoans",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ff7601",
    style: {
      fill: "var(--color1, #ff7601)"
    },
    d: "M15.792 20.364c-1.385 0-2.563-0.485-3.532-1.454s-1.455-2.147-1.455-3.532 0.485-2.563 1.455-3.532c0.97-0.97 2.147-1.455 3.532-1.455s2.563 0.485 3.532 1.455c0.97 0.97 1.455 2.147 1.455 3.532s-0.485 2.563-1.455 3.532c-0.97 0.97-2.147 1.454-3.533 1.454zM2.494 26.182c-0.686 0-1.273-0.244-1.761-0.733s-0.732-1.075-0.732-1.761v-16.623c0-0.686 0.244-1.273 0.732-1.761s1.075-0.732 1.761-0.732h26.597c0.686 0 1.273 0.244 1.761 0.732s0.733 1.075 0.733 1.761v16.623c0 0.686-0.244 1.273-0.733 1.761s-1.075 0.733-1.761 0.733h-26.597zM6.649 23.688h18.286c0-1.164 0.402-2.147 1.205-2.951s1.787-1.205 2.951-1.205v-8.312c-1.164 0-2.147-0.402-2.951-1.205s-1.205-1.787-1.205-2.951h-18.286c0 1.164-0.402 2.147-1.205 2.951s-1.787 1.205-2.951 1.205v8.312c1.164 0 2.147 0.402 2.951 1.205s1.205 1.787 1.205 2.951z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-pets",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ff7601",
    style: {
      fill: "var(--color1, #ff7601)"
    },
    d: "M7.273 12.872c-0.295-2.817-1.921-4.448-3.781-4.448v0.003c-0.112-0-0.224 0.006-0.336 0.017-1.996 0.205-3.421 2.197-3.112 5.183 0.299 2.856 2.025 5.040 3.923 5.040 0.086 0 0.172-0.004 0.257-0.013 2-0.208 3.361-2.8 3.049-5.781zM3.945 15.984c-0.779-0.655-1.154-1.573-1.249-2.635 0-0.671-0.006-1.334 0.292-1.931 0.166-0.312 0.368-0.317 0.445-0.325l0.059-0.001c0.449 0 0.994 0.768 1.129 2.056 0.092 1.003-0.050 2.034-0.676 2.836z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff7601",
    style: {
      fill: "var(--color1, #ff7601)"
    },
    d: "M11.29 11.267c0.095 0 0.188 0 0.283-0.015 2.196-0.229 3.697-3.077 3.355-6.36-0.324-3.097-2.113-4.892-4.159-4.892-0.123 0-0.246 0.007-0.368 0.020-2.197 0.228-3.768 2.419-3.425 5.703 0.329 3.141 2.225 5.544 4.315 5.544zM9.988 3.147c0.134-0.265 0.392-0.445 0.687-0.48 0.031-0.002 0.062-0.002 0.093 0 0.619 0 1.333 0.86 1.507 2.503 0.125 0.955-0.025 1.927-0.432 2.8-0.243 0.46-0.487 0.62-0.553 0.627-0.343 0-1.445-1.085-1.663-3.155-0.139-0.784-0.012-1.592 0.361-2.295z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff7601",
    style: {
      fill: "var(--color1, #ff7601)"
    },
    d: "M20.486 11.252c0.095 0.009 0.189 0.015 0.283 0.015 2.087 0 3.987-2.4 4.315-5.544 0.343-3.284-1.228-5.475-3.423-5.703-0.123-0.013-0.246-0.020-0.369-0.020-2.047 0-3.836 1.795-4.16 4.892-0.343 3.283 1.159 6.133 3.355 6.36zM19.785 5.168c0.171-1.641 0.883-2.501 1.507-2.501 0.031-0.002 0.061-0.002 0.092 0 0.294 0.035 0.552 0.215 0.687 0.479 0.375 0.703 0.502 1.511 0.361 2.295-0.216 2.069-1.32 3.155-1.668 3.155-0.061 0-0.305-0.167-0.548-0.627-0.407-0.873-0.556-1.845-0.431-2.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff7601",
    style: {
      fill: "var(--color1, #ff7601)"
    },
    d: "M16.001 14.667c-6.056 0-12 6.188-12.008 12.492-0.165 4.265 3.467 5.811 7.867 4.237 2.682-0.915 5.592-0.915 8.275 0 1.033 0.349 2.111 0.552 3.2 0.604 3.857 0 4.667-2.633 4.667-4.841 0-6.304-5.944-12.492-12-12.492zM16.001 28c-3.005-0.476-9.632 3.777-9.333-0.841 0-4.867 4.711-9.825 9.333-9.825s9.333 4.959 9.333 9.825c0.301 4.615-6.313 0.371-9.333 0.841z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff7601",
    style: {
      fill: "var(--color1, #ff7601)"
    },
    d: "M29.295 9.854l-0.001 0.003c-0.109-0.026-0.22-0.046-0.331-0.061-1.989-0.261-3.836 1.349-4.224 4.325-0.368 2.848 0.808 5.371 2.654 5.809 0.084 0.020 0.168 0.035 0.253 0.046 1.994 0.259 3.917-1.949 4.301-4.922 0.363-2.809-0.843-4.771-2.653-5.2zM29.304 14.711c-0.142 0.997-0.518 1.967-1.312 2.603-0.607-0.817-0.76-1.797-0.608-2.852 0.155-0.653 0.302-1.299 0.73-1.811 0.233-0.265 0.431-0.224 0.508-0.214l0.057 0.013c0.437 0.104 0.791 0.976 0.624 2.261z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-redross",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ff1717",
    style: {
      fill: "var(--color4, #ff1717)"
    },
    d: "M16 0c-8.848 0-16 7.152-16 16s7.152 16 16 16c8.848 0 16-7.152 16-16s-7.152-16-16-16zM16 28.8c-7.056 0-12.8-5.744-12.8-12.8s5.744-12.8 12.8-12.8c7.056 0 12.8 5.744 12.8 12.8s-5.744 12.8-12.8 12.8zM21.744 8l-5.744 5.744-5.744-5.744-2.256 2.256 5.744 5.744-5.744 5.744 2.256 2.256 5.744-5.744 5.744 5.744 2.256-2.256-5.744-5.744 5.744-5.744-2.256-2.256z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-rent",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ff7601",
    style: {
      fill: "var(--color1, #ff7601)"
    },
    d: "M5.333 17.333h4v2.667h-4v-2.667zM12 20h4v-2.667h-4v2.667zM5.333 25.333h4v-2.667h-4v2.667zM12 25.333h4v-2.667h-4v2.667zM5.333 9.333h4v-2.667h-4v2.667zM12 9.333h4v-2.667h-4v2.667zM5.333 14.667h4v-2.667h-4v2.667zM12 14.667h4v-2.667h-4v2.667zM32 10.667v21.333h-32v-28c0-1.061 0.421-2.078 1.172-2.828s1.768-1.172 2.828-1.172h13.333c1.061 0 2.078 0.421 2.828 1.172s1.172 1.768 1.172 2.828v2.667h6.667c1.061 0 2.078 0.421 2.828 1.172s1.172 1.768 1.172 2.828zM18.667 4c0-0.354-0.141-0.693-0.391-0.943s-0.589-0.391-0.943-0.391h-13.333c-0.354 0-0.693 0.14-0.943 0.391s-0.391 0.589-0.391 0.943v25.333h16v-25.333zM29.333 10.667c0-0.354-0.141-0.693-0.391-0.943s-0.589-0.391-0.943-0.391h-6.667v20h8v-18.667zM24 20h2.667v-2.667h-2.667v2.667zM24 25.333h2.667v-2.667h-2.667v2.667zM24 14.667h2.667v-2.667h-2.667v2.667z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-restaurants",
    viewBox: "0 0 27 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ff7601",
    style: {
      fill: "var(--color1, #ff7601)"
    },
    d: "M10.667-0h2.667v12c0 1.061-0.421 2.078-1.172 2.828s-1.768 1.172-2.828 1.172h-1.333v16h-2.667v-16h-1.333c-1.061 0-2.078-0.421-2.828-1.172s-1.172-1.768-1.172-2.828v-12h2.667v12c0 0.354 0.14 0.693 0.391 0.943s0.589 0.391 0.943 0.391h1.333v-13.333h2.667v13.333h1.333c0.354 0 0.693-0.14 0.943-0.391s0.391-0.589 0.391-0.943v-12zM26.667 12.356c0 6.236-5.169 12.255-6.667 13.867v5.777h-2.667v-29.333c-0-0.561 0.177-1.109 0.506-1.563s0.793-0.794 1.327-0.97c0.533-0.176 1.108-0.178 1.643-0.008s1.003 0.505 1.336 0.957c2.061 2.767 4.521 6.969 4.521 11.273zM20 22.036c5.2-6.704 5.227-12.636 0-19.36v19.36z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-salary",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ff7601",
    style: {
      fill: "var(--color1, #ff7601)"
    },
    d: "M18.182 17.818c-1.212 0-2.243-0.424-3.091-1.273s-1.273-1.879-1.273-3.091 0.424-2.242 1.273-3.091c0.848-0.848 1.879-1.273 3.091-1.273s2.242 0.424 3.091 1.273c0.849 0.848 1.273 1.879 1.273 3.091s-0.424 2.242-1.273 3.091c-0.848 0.849-1.879 1.273-3.091 1.273zM6.545 22.909c-0.6 0-1.114-0.214-1.541-0.641s-0.641-0.941-0.641-1.541v-14.546c0-0.6 0.214-1.114 0.641-1.541s0.941-0.641 1.541-0.641h23.273c0.6 0 1.114 0.214 1.541 0.641s0.641 0.941 0.641 1.541v14.546c0 0.6-0.214 1.114-0.641 1.541s-0.941 0.641-1.541 0.641h-23.273zM10.182 20.727h16c0-1.018 0.351-1.879 1.055-2.582s1.564-1.055 2.582-1.055v-7.273c-1.018 0-1.879-0.352-2.582-1.055s-1.055-1.564-1.055-2.582h-16c0 1.018-0.351 1.879-1.055 2.582s-1.564 1.055-2.582 1.055v7.273c1.018 0 1.879 0.352 2.582 1.055s1.055 1.564 1.055 2.582zM27.636 27.273h-25.455c-0.6 0-1.114-0.214-1.541-0.641s-0.641-0.941-0.641-1.541v-16.727h2.182v16.727h25.455v2.182z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-self",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ff7601",
    style: {
      fill: "var(--color1, #ff7601)"
    },
    d: "M24 4v1.333h8v2.667h-8v2.667h8v2.667h-8v2.667h8v2.667h-8v2.667h8v2.667h-8v8h-2.667v-28c0-1.061 0.421-2.078 1.172-2.828s1.767-1.172 2.828-1.172h6.667v2.667h-6.667c-0.354 0-0.693 0.14-0.943 0.391s-0.391 0.589-0.391 0.943v0zM18.667 26.667c0.005 1.086-0.323 2.147-0.94 3.041s-1.493 1.577-2.51 1.957c-1.017 0.38-2.126 0.44-3.178 0.17s-1.996-0.855-2.705-1.677c-0.559 0.643-1.264 1.142-2.056 1.456s-1.648 0.432-2.495 0.346c-0.848-0.086-1.662-0.375-2.375-0.841s-1.303-1.097-1.721-1.84c-0.418-0.742-0.652-1.574-0.682-2.425s0.146-1.697 0.511-2.467c0.365-0.769 0.91-1.44 1.589-1.955s1.471-0.859 2.311-1.004l3.468-8.093-2.199-5.132c-1.114-2.591-1.687-5.381-1.684-8.201h2.667c-0.003 2.459 0.496 4.893 1.467 7.152l1.2 2.8 1.2-2.8c0.971-2.259 1.47-4.693 1.467-7.152h2.667c0.003 2.82-0.57 5.611-1.684 8.201l-2.199 5.132 3.467 8.093c1.234 0.215 2.353 0.859 3.161 1.817s1.252 2.17 1.255 3.423zM8 26.667c0-0.527-0.156-1.043-0.449-1.481s-0.71-0.78-1.197-0.982c-0.487-0.202-1.023-0.255-1.541-0.152s-0.992 0.357-1.365 0.73-0.627 0.848-0.73 1.365c-0.103 0.517-0.050 1.053 0.152 1.541s0.544 0.904 0.982 1.197c0.439 0.293 0.954 0.449 1.482 0.449 0.707 0 1.386-0.281 1.886-0.781s0.781-1.178 0.781-1.886zM9.333 23.176c0.577-0.665 1.31-1.176 2.133-1.487l-2.133-4.972-2.133 4.972c0.823 0.311 1.556 0.822 2.133 1.487v0zM16 26.667c0-0.527-0.156-1.043-0.449-1.481s-0.709-0.78-1.197-0.982c-0.487-0.202-1.024-0.255-1.541-0.152s-0.992 0.357-1.365 0.73-0.627 0.848-0.73 1.365c-0.103 0.517-0.050 1.053 0.152 1.541s0.544 0.904 0.982 1.197c0.439 0.293 0.954 0.449 1.482 0.449 0.707 0 1.385-0.281 1.886-0.781s0.781-1.178 0.781-1.886z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-shipping",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ff7601",
    style: {
      fill: "var(--color1, #ff7601)"
    },
    d: "M28 1.334h-24c-1.061 0-2.078 0.421-2.828 1.172s-1.172 1.768-1.172 2.828v25.333h32v-25.333c0-1.061-0.421-2.078-1.172-2.828s-1.768-1.172-2.828-1.172zM4 4h24c0.354 0 0.693 0.14 0.943 0.391s0.391 0.589 0.391 0.943v0.889l-10.504 10.505c-0.751 0.749-1.769 1.169-2.829 1.169s-2.078-0.42-2.829-1.169l-10.504-10.505v-0.889c0-0.354 0.14-0.693 0.391-0.943s0.589-0.391 0.943-0.391zM2.667 28v-18l8.619 8.613c1.252 1.248 2.947 1.949 4.715 1.949s3.463-0.701 4.715-1.949l8.619-8.613v18h-26.667z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-sport",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ff7601",
    style: {
      fill: "var(--color1, #ff7601)"
    },
    d: "M30.828 9.496l-3.219-3.22 2.667-2.667-1.885-1.885-2.667 2.667-3.219-3.219c-0.371-0.371-0.812-0.666-1.298-0.867s-1.006-0.305-1.531-0.305c-0.525 0-1.046 0.103-1.531 0.305s-0.926 0.496-1.298 0.867l-3.771 3.771 6.047 6.048-8.133 8.133-6.048-6.047-3.771 3.771c-0.75 0.75-1.171 1.767-1.171 2.828s0.421 2.078 1.171 2.828l3.219 3.22-2.667 2.667 1.885 1.885 2.667-2.667 3.219 3.219c0.371 0.371 0.812 0.666 1.298 0.867s1.006 0.305 1.531 0.305 1.046-0.104 1.531-0.305c0.485-0.201 0.926-0.496 1.298-0.867l3.771-3.771-6.047-6.048 8.133-8.133 6.047 6.047 3.771-3.771c0.75-0.75 1.171-1.767 1.171-2.828s-0.421-2.078-1.171-2.828h0.001zM13.267 28.943c-0.124 0.124-0.271 0.222-0.433 0.289s-0.335 0.102-0.511 0.102-0.349-0.035-0.511-0.102c-0.162-0.067-0.309-0.165-0.433-0.289l-8.323-8.324c-0.25-0.25-0.39-0.589-0.39-0.943s0.14-0.693 0.39-0.943l1.885-1.885 10.209 10.209-1.885 1.885zM28.943 13.265l-1.885 1.887-10.209-10.209 1.885-1.885c0.124-0.124 0.271-0.222 0.433-0.289s0.335-0.102 0.511-0.102c0.175 0 0.349 0.035 0.511 0.102s0.309 0.165 0.433 0.289l8.323 8.324c0.25 0.25 0.39 0.589 0.39 0.942s-0.14 0.692-0.39 0.942v0z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-toys",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ff7601",
    style: {
      fill: "var(--color1, #ff7601)"
    },
    d: "M25.013 21.333c-0.918-0.003-1.828 0.177-2.676 0.528s-1.619 0.867-2.266 1.519l-4 4c-0.618 0.621-1.353 1.113-2.162 1.449s-1.677 0.507-2.553 0.505h-7.192c-0.296 0-0.585-0.087-0.831-0.252s-0.438-0.398-0.551-0.671c-0.113-0.273-0.143-0.574-0.085-0.864s0.2-0.556 0.409-0.765l4.253-4.248 17.671-4.713c0.852-0.227 1.605-0.73 2.142-1.429s0.828-1.557 0.827-2.439v-9.952c0-1.061-0.421-2.078-1.172-2.828s-1.768-1.172-2.828-1.172h-9.952c-0.882-0-1.739 0.291-2.438 0.828s-1.201 1.29-1.429 2.142l-4.715 17.677-4.245 4.249c-0.582 0.582-0.978 1.323-1.139 2.131s-0.078 1.644 0.237 2.404 0.848 1.41 1.533 1.868c0.684 0.457 1.489 0.701 2.312 0.701h7.192c1.226 0.003 2.441-0.237 3.574-0.706s2.161-1.159 3.026-2.028l4-4c0.605-0.603 1.375-1.014 2.213-1.18s1.706-0.080 2.496 0.247c0.789 0.327 1.464 0.881 1.939 1.591s0.729 1.545 0.73 2.399v3.677h2.667v-3.677c-0.003-1.852-0.739-3.628-2.049-4.939s-3.085-2.048-4.938-2.051v0zM25.333 4.555v8.227l-4.113-4.115 4.113-4.112zM19.333 6.783l-4.115-4.116h8.232l-4.117 4.116zM24.088 15.308l-12.965 3.457 8.211-8.212 4.755 4.755zM12.692 3.911l4.757 4.756-8.216 8.217 3.459-12.973z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-transport",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ff7601",
    style: {
      fill: "var(--color1, #ff7601)"
    },
    d: "M6.55 31.091c-0.355 0-0.668-0.102-0.941-0.307s-0.409-0.471-0.409-0.798v-3.436c-0.791-0.436-1.37-1.064-1.739-1.882s-0.552-1.691-0.552-2.618v-16.241c0-2.018 1.043-3.491 3.13-4.418s5.42-1.391 10.002-1.391c4.527 0 7.834 0.464 9.92 1.391s3.13 2.4 3.13 4.418v16.241c0 0.927-0.184 1.8-0.552 2.618s-0.948 1.445-1.739 1.882v3.436c0 0.327-0.136 0.593-0.409 0.798s-0.586 0.307-0.941 0.307h-0.777c-0.382 0-0.709-0.102-0.982-0.307s-0.409-0.471-0.409-0.798v-2.25h-14.564v2.25c0 0.327-0.136 0.593-0.409 0.798s-0.6 0.307-0.982 0.307h-0.777zM16.041 4.745v0zM23.282 16.732v0zM5.364 14.277h21.273v-7.077h-21.273v7.077zM9.7 23.236c0.627 0 1.159-0.218 1.595-0.655s0.655-0.968 0.655-1.596c0-0.627-0.218-1.159-0.655-1.596s-0.968-0.655-1.595-0.655c-0.627 0-1.159 0.218-1.595 0.655s-0.655 0.968-0.655 1.596c0 0.627 0.218 1.159 0.655 1.596s0.968 0.655 1.595 0.655zM22.3 23.236c0.627 0 1.159-0.218 1.596-0.655s0.655-0.968 0.655-1.596c0-0.627-0.218-1.159-0.655-1.596s-0.968-0.655-1.596-0.655c-0.627 0-1.159 0.218-1.595 0.655s-0.655 0.968-0.655 1.596c0 0.627 0.218 1.159 0.655 1.596s0.968 0.655 1.595 0.655zM5.364 4.745h21.273c-0.655-0.709-1.909-1.268-3.764-1.677s-4.132-0.614-6.832-0.614c-3.218 0-5.686 0.184-7.405 0.552s-2.809 0.948-3.273 1.739zM8.718 25.282h14.564c0.955 0 1.752-0.368 2.393-1.105s0.961-1.582 0.961-2.536v-4.909h-21.273v4.909c0 0.955 0.32 1.8 0.961 2.536s1.439 1.105 2.393 1.105z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-trips",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ff7601",
    style: {
      fill: "var(--color1, #ff7601)"
    },
    d: "M28 13.333h-4.409l-5.663-11.249c-0.344-0.631-0.852-1.157-1.47-1.524s-1.323-0.56-2.042-0.56h-4.909l3.867 13.333h-4.84l-3.067-3.060c-0.347-0.347-0.769-0.609-1.233-0.766s-0.959-0.206-1.445-0.143c-0.486 0.064-0.951 0.238-1.359 0.51s-0.748 0.634-0.994 1.058c-0.285 0.485-0.436 1.036-0.438 1.599s0.146 1.115 0.428 1.601l4.117 7.2h8.816l-4 10.667h5.057c0.706 0.004 1.401-0.181 2.011-0.536s1.115-0.866 1.462-1.482l5.396-8.649h8.715v-4c0-1.061-0.421-2.078-1.171-2.828s-1.768-1.172-2.829-1.172zM13.056 2.667h1.36c0.233-0.002 0.461 0.058 0.663 0.172s0.37 0.281 0.487 0.482l5.040 10.012h-4.46l-3.091-10.667zM29.334 18.667h-7.528l-6.219 9.972c-0.115 0.21-0.284 0.386-0.49 0.508s-0.441 0.187-0.681 0.187h-1.216l4-10.667h-11.111l-3.349-5.867c-0.047-0.082-0.072-0.174-0.071-0.268s0.025-0.187 0.073-0.268c0.048-0.081 0.116-0.149 0.198-0.195s0.175-0.070 0.269-0.069c0.071-0 0.141 0.014 0.206 0.041s0.124 0.067 0.174 0.117l3.843 3.843h20.569c0.354 0 0.693 0.141 0.943 0.391s0.39 0.589 0.39 0.943v1.333z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-utilities",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ff751d",
    style: {
      fill: "var(--color3, #ff751d)",
      stroke: "var(--color3, #ff751d)"
    },
    stroke: "#ff751d",
    strokeLinejoin: "miter",
    strokeLinecap: "butt",
    strokeMiterlimit: 4,
    strokeWidth: 1.4545,
    d: "M2.31 12.193h-0.856v-7.701h1.711v7.701h-0.856zM25.032 22.956c0.284-0.388 0.57-0.723 0.808-0.986 0.238 0.263 0.524 0.599 0.808 0.986 0.72 0.984 1.331 2.158 1.331 3.238 0 1.277-0.988 2.255-2.139 2.255s-2.139-0.979-2.139-2.255c0-1.080 0.611-2.255 1.331-3.238zM29.69 14.759h0.856v3.422h-10.267v-3.422h1.711v-1.711c0-0.681-0.27-1.334-0.752-1.815s-1.134-0.752-1.815-0.752v-6.845h1.711c2.042 0 4.001 0.811 5.445 2.255s2.255 3.403 2.255 5.445v3.422h0.856zM11.722 3.636h4.278v9.412h-9.412v-9.412h5.134z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-geo",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#52555f",
    style: {
      fill: "var(--color1, #52555f)"
    },
    d: "M15.944 32.011l-0.929-0.797c-1.281-1.073-12.469-10.735-12.469-17.803 0-7.4 5.999-13.399 13.399-13.399s13.399 5.999 13.399 13.399c0 7.068-11.188 16.73-12.464 17.808l-0.935 0.791zM15.944 2.91c-5.797 0.007-10.495 4.704-10.501 10.501 0 4.44 6.883 11.533 10.501 14.78 3.618-3.248 10.501-10.345 10.501-14.78-0.007-5.797-4.704-10.495-10.501-10.501z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52555f",
    style: {
      fill: "var(--color1, #52555f)"
    },
    d: "M15.944 18.722c-2.933 0-5.311-2.378-5.311-5.311s2.378-5.311 5.311-5.311c2.933 0 5.311 2.378 5.311 5.311s-2.378 5.311-5.311 5.311zM15.944 10.755c-1.467 0-2.656 1.189-2.656 2.656s1.189 2.656 2.656 2.656c1.467 0 2.656-1.189 2.656-2.656s-1.189-2.656-2.656-2.656z"
  })), _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "plus",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 14.667h-14.667v-14.667h-2.667v14.667h-14.667v2.667h14.667v14.667h2.667v-14.667h14.667v-2.667z"
  }))), _symbol2 || (_symbol2 = /*#__PURE__*/React.createElement("symbol", {
    id: "home",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.784 1.111c-0.49-0.441-1.125-0.685-1.784-0.685s-1.294 0.244-1.784 0.685l-14.216 12.795v13.867c0 1.132 0.45 2.217 1.25 3.017s1.885 1.25 3.017 1.25h23.467c1.132 0 2.217-0.45 3.017-1.25s1.25-1.885 1.25-3.017v-13.867l-14.216-12.795zM20 29.368h-8v-6.701c0-1.061 0.421-2.078 1.172-2.829s1.768-1.171 2.828-1.171c1.061 0 2.078 0.421 2.828 1.171s1.172 1.768 1.172 2.829v6.701zM29.333 27.768c0 0.424-0.169 0.831-0.469 1.131s-0.707 0.469-1.131 0.469h-5.067v-6.701c0-1.768-0.702-3.464-1.953-4.714s-2.946-1.953-4.714-1.953-3.464 0.702-4.714 1.953c-1.25 1.25-1.953 2.946-1.953 4.714v6.701h-5.067c-0.424 0-0.831-0.169-1.131-0.469s-0.469-0.707-0.469-1.131v-12.676l13.333-12 13.333 12v12.676z"
  }))), _symbol3 || (_symbol3 = /*#__PURE__*/React.createElement("symbol", {
    id: "planning",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.504 6.828l-2.113-2.113 1.885-1.885 2.115 2.113c0.254 0.243 0.591 0.378 0.943 0.378s0.689-0.135 0.943-0.378l4.781-4.78 1.885 1.885-4.781 4.78c-0.371 0.372-0.812 0.666-1.298 0.867s-1.006 0.305-1.531 0.305c-0.525 0-1.046-0.103-1.531-0.305s-0.926-0.496-1.298-0.867zM16 6.667h16v-2.667h-16v2.667zM5.334 18.667c0.525 0.001 1.046-0.101 1.532-0.303s0.926-0.497 1.296-0.869l4.781-4.78-1.885-1.885-4.781 4.78c-0.254 0.243-0.591 0.378-0.943 0.378s-0.689-0.135-0.943-0.378l-2.115-2.113-1.885 1.885 2.113 2.113c0.371 0.373 0.812 0.668 1.297 0.869s1.006 0.304 1.532 0.303zM16 17.333h16v-2.667h-16v2.667zM5.334 29.333c0.525 0.001 1.046-0.101 1.532-0.303s0.926-0.497 1.296-0.869l4.781-4.78-1.885-1.885-4.781 4.78c-0.254 0.243-0.591 0.378-0.943 0.378s-0.689-0.135-0.943-0.378l-2.115-2.113-1.885 1.885 2.113 2.113c0.371 0.373 0.812 0.668 1.297 0.869s1.006 0.304 1.532 0.303zM16 28h16v-2.667h-16v2.667z"
  }))), _symbol4 || (_symbol4 = /*#__PURE__*/React.createElement("symbol", {
    id: "report",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.667 27.968v-28h-2.667v28c0 1.061 0.421 2.078 1.172 2.828s1.768 1.172 2.828 1.172h28v-2.667h-28c-0.354 0-0.693-0.141-0.943-0.391s-0.391-0.589-0.391-0.943z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 5.301h-7.333l3.724 3.724-5.724 5.724-2.667-2.667-9.625 9.625 1.892 1.892 7.74-7.733 2.667 2.667 7.609-7.609 3.717 3.711v-7.333c0-0.53-0.211-1.039-0.586-1.414s-0.884-0.586-1.414-0.586z"
  }))), _symbol5 || (_symbol5 = /*#__PURE__*/React.createElement("symbol", {
    id: "wallets",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.333 22.667c1.105 0 2-0.895 2-2s-0.895-2-2-2-2 0.895-2 2c0 1.105 0.895 2 2 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 4h-24c-1.061 0-2.078 0.421-2.828 1.172s-1.172 1.768-1.172 2.828v20h32v-20c0-1.061-0.421-2.078-1.172-2.828s-1.768-1.172-2.828-1.172zM4 6.667h24c0.354 0 0.693 0.14 0.943 0.391s0.391 0.589 0.391 0.943v2.667h-26.667v-2.667c0-0.354 0.14-0.693 0.391-0.943s0.589-0.391 0.943-0.391zM2.667 25.333v-12h26.667v12h-26.667z"
  }))), _symbol6 || (_symbol6 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-arrow-down",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.258 12.876l1.885-1.829 7.057 6.856 7.057-6.856 1.885 1.834-7.057 6.851c-0.5 0.486-1.178 0.759-1.885 0.759s-1.385-0.273-1.885-0.759l-7.057-6.856z"
  }))), _symbol7 || (_symbol7 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-edit",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.587 1.411c-0.907-0.905-2.135-1.413-3.416-1.413s-2.51 0.508-3.416 1.413l-23.755 23.755v6.832h6.832l23.755-23.755c0.905-0.907 1.413-2.135 1.413-3.416s-0.508-2.509-1.413-3.416zM5.733 29.332h-3.067v-3.067l17.747-17.733 3.067 3.067-17.747 17.733zM28.701 6.358l-3.343 3.343-3.060-3.067 3.341-3.337c0.407-0.407 0.958-0.635 1.533-0.635s1.127 0.228 1.533 0.635c0.407 0.407 0.635 0.958 0.635 1.533s-0.228 1.127-0.635 1.533l-0.005-0.005z"
  }))), _symbol8 || (_symbol8 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-search",
    viewBox: "0 0 31 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.72 29.551l-8.015-8.015c2.082-2.546 3.106-5.796 2.859-9.076s-1.744-6.34-4.183-8.547c-2.439-2.207-5.633-3.392-8.922-3.309s-6.419 1.425-8.745 3.751-3.669 5.457-3.751 8.745c-0.082 3.288 1.103 6.482 3.309 8.921s5.267 3.937 8.547 4.183c3.28 0.246 6.529-0.777 9.076-2.859l8.015 8.015 1.81-1.81zM12.8 23.681c-2.025 0-4.005-0.601-5.689-1.726s-2.996-2.724-3.771-4.596-0.978-3.93-0.583-5.916c0.395-1.986 1.37-3.811 2.802-5.243s3.257-2.407 5.243-2.802c1.986-0.395 4.045-0.192 5.916 0.583s3.47 2.088 4.596 3.771c1.125 1.684 1.726 3.664 1.726 5.689-0.003 2.715-1.083 5.318-3.003 7.237s-4.523 3-7.237 3.003z"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-trash",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#ff7601",
    style: {
      stroke: "var(--color1, #ff7601)"
    },
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.6667,
    d: "M4 8h24"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#ff7601",
    style: {
      stroke: "var(--color1, #ff7601)"
    },
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.6667,
    d: "M25.333 8v18.667c0 0.707-0.281 1.385-0.781 1.886s-1.178 0.781-1.886 0.781h-13.333c-0.707 0-1.386-0.281-1.886-0.781s-0.781-1.178-0.781-1.886v-18.667M10.667 8v-2.667c0-0.707 0.281-1.386 0.781-1.886s1.178-0.781 1.886-0.781h5.333c0.707 0 1.385 0.281 1.886 0.781s0.781 1.178 0.781 1.886v2.667"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-three-dots",
    viewBox: "0 0 6 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ff7601",
    style: {
      fill: "var(--color1, #ff7601)"
    },
    d: "M6.4 3.2c0 1.767-1.433 3.2-3.2 3.2s-3.2-1.433-3.2-3.2c0-1.767 1.433-3.2 3.2-3.2s3.2 1.433 3.2 3.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff7601",
    style: {
      fill: "var(--color1, #ff7601)"
    },
    d: "M6.4 16c0 1.767-1.433 3.2-3.2 3.2s-3.2-1.433-3.2-3.2c0-1.767 1.433-3.2 3.2-3.2s3.2 1.433 3.2 3.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff7601",
    style: {
      fill: "var(--color1, #ff7601)"
    },
    d: "M6.4 28.8c0 1.767-1.433 3.2-3.2 3.2s-3.2-1.433-3.2-3.2c0-1.767 1.433-3.2 3.2-3.2s3.2 1.433 3.2 3.2z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-charity",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ff7601",
    style: {
      fill: "var(--color1, #ff7601)"
    },
    d: "M23.086 16.152c-1.194-1.067-2.33-2.108-3.409-3.124s-2.025-2.006-2.836-2.969-1.459-1.897-1.943-2.798c-0.484-0.902-0.726-1.773-0.726-2.613 0-1.314 0.447-2.418 1.342-3.31s2.001-1.338 3.319-1.338c0.753 0 1.504 0.21 2.254 0.629s1.416 0.984 2 1.695c0.584-0.711 1.251-1.276 2-1.695s1.5-0.629 2.254-0.629c1.318 0 2.424 0.446 3.319 1.338s1.342 1.995 1.342 3.31c0 0.84-0.242 1.711-0.726 2.613s-1.132 1.835-1.943 2.798c-0.811 0.964-1.759 1.956-2.842 2.976s-2.218 2.059-3.403 3.117zM23.086 12.99c1.676-1.524 3.2-3.035 4.572-4.533s2.057-2.768 2.057-3.81c0-0.696-0.22-1.264-0.661-1.703s-1.011-0.659-1.71-0.659c-0.426 0-0.848 0.102-1.267 0.305s-0.845 0.584-1.276 1.143l-1.714 2.095-1.714-2.095c-0.432-0.559-0.857-0.94-1.276-1.143s-0.841-0.305-1.267-0.305c-0.699 0-1.269 0.22-1.71 0.659s-0.661 1.007-0.661 1.703c0 1.041 0.686 2.311 2.057 3.81s2.895 3.009 4.571 4.533zM20.038 31.238l-11.848-3.391v2.172h-8.19v-15.010h11.771l9.714 3.657c0.686 0.254 1.264 0.667 1.733 1.238s0.705 1.391 0.705 2.457h4.343c1.067 0 1.956 0.381 2.667 1.143s1.067 1.791 1.067 3.086v0.99l-11.962 3.657zM2.286 27.733h3.581v-10.438h-3.581v10.438zM19.886 28.876l9.752-2.971c-0.152-0.482-0.343-0.813-0.572-0.99s-0.495-0.267-0.8-0.267h-7.886c-0.762 0-1.467-0.051-2.114-0.152s-1.263-0.241-1.848-0.419l-3.086-0.952 0.838-2.209 2.781 0.914c0.635 0.203 1.238 0.343 1.809 0.419s1.479 0.114 2.724 0.114c0-0.305-0.057-0.603-0.171-0.895s-0.311-0.502-0.591-0.628l-9.333-3.543h-3.2v8.152l11.695 3.429z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-Car-service",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ff7601",
    style: {
      fill: "var(--color1, #ff7601)"
    },
    d: "M25.848 31.513l-11.419-11.508c-0.679 0.236-1.357 0.428-2.036 0.575s-1.372 0.221-2.080 0.221c-2.865 0-5.3-0.998-7.305-2.995s-3.008-4.421-3.008-7.273c0-0.915 0.12-1.806 0.361-2.673s0.578-1.688 1.011-2.461l6.418 6.418 4.072-3.806-6.595-6.595c0.765-0.447 1.575-0.795 2.432-1.044s1.728-0.373 2.613-0.373c2.926 0 5.413 1.024 7.461 3.072s3.072 4.535 3.072 7.462c0 0.708-0.074 1.402-0.221 2.080s-0.339 1.357-0.575 2.036l11.463 11.419c0.325 0.323 0.487 0.714 0.487 1.172s-0.162 0.849-0.487 1.174l-3.364 3.098c-0.316 0.325-0.697 0.487-1.144 0.487s-0.833-0.162-1.157-0.487zM27.087 28.99l1.77-1.77-12.083-12.083c0.472-0.62 0.826-1.35 1.062-2.191s0.354-1.645 0.354-2.412c0-2.213-0.819-4.087-2.456-5.621s-3.504-2.316-5.599-2.346l4.47 4.559c0.265 0.266 0.398 0.59 0.398 0.974s-0.133 0.708-0.398 0.974l-5.842 5.488c-0.266 0.265-0.59 0.398-0.974 0.398s-0.708-0.133-0.974-0.398l-4.293-4.249c0.089 2.272 0.895 4.146 2.42 5.621s3.315 2.213 5.37 2.213c0.738 0 1.52-0.118 2.346-0.354s1.549-0.59 2.169-1.062l12.26 12.26z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-bitcoin",
    viewBox: "0 0 23 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ff7601",
    style: {
      fill: "var(--color1, #ff7601)"
    },
    d: "M5.714 31.648v-3.956h-5.714v-2.637h3.956v-18.462h-3.956v-2.637h5.714v-3.956h2.637v3.956h4.835v-3.956h2.637v4.088c1.582 0.322 2.857 1.099 3.824 2.33s1.451 2.608 1.451 4.132c0 0.82-0.161 1.634-0.484 2.44s-0.791 1.531-1.406 2.176c1.143 0.586 2.037 1.414 2.681 2.483s0.967 2.22 0.967 3.451c0 1.817-0.637 3.37-1.912 4.659s-2.835 1.934-4.681 1.934h-0.44v3.956h-2.637v-3.956h-4.835v3.956h-2.637zM6.593 14.505h7.912c1.114 0 2.051-0.388 2.813-1.165s1.143-1.707 1.143-2.791c0-1.114-0.381-2.051-1.143-2.813s-1.7-1.143-2.813-1.143h-7.912v7.912zM6.593 25.055h9.67c1.113 0 2.051-0.388 2.813-1.165s1.143-1.707 1.143-2.791c0-1.114-0.381-2.051-1.143-2.813s-1.7-1.143-2.813-1.143h-9.67v7.912z"
  })), _symbol9 || (_symbol9 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-close",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.333 8.547l-1.88-1.88-7.453 7.453-7.453-7.453-1.88 1.88 7.453 7.453-7.453 7.453 1.88 1.88 7.453-7.453 7.453 7.453 1.88-1.88-7.453-7.453 7.453-7.453z"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-light-gear",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ebebeb",
    style: {
      fill: "var(--color1, #ebebeb)"
    },
    d: "M30.987 11.422l-4.317-7.518-2.32 1.338c-0.334 0.191-0.714 0.285-1.099 0.271s-0.757-0.135-1.076-0.349c-0.36-0.235-0.733-0.451-1.115-0.647-0.337-0.174-0.62-0.439-0.817-0.763s-0.3-0.697-0.299-1.077v-2.677h-8.723v2.677c-0.001 0.379-0.105 0.751-0.302 1.075s-0.478 0.589-0.813 0.765c-0.39 0.201-0.77 0.413-1.115 0.647-0.325 0.226-0.708 0.353-1.104 0.367s-0.787-0.086-1.127-0.289l-2.398-1.338-4.361 7.563 2.32 1.338c0.331 0.194 0.601 0.476 0.78 0.815s0.261 0.721 0.235 1.104c0 0.212 0 0.435 0 0.647s0 0.424 0 0.647c0.029 0.38-0.050 0.761-0.228 1.098s-0.446 0.618-0.776 0.809l-2.331 1.35 4.361 7.563 2.32-1.338c0.334-0.191 0.714-0.285 1.099-0.271s0.757 0.135 1.076 0.349c0.36 0.235 0.733 0.451 1.115 0.647 0.336 0.176 0.617 0.441 0.813 0.765s0.301 0.696 0.302 1.075v2.61h8.723v-2.677c-0.001-0.38 0.102-0.752 0.299-1.077s0.479-0.589 0.817-0.763c0.39-0.201 0.759-0.413 1.115-0.647 0.319-0.214 0.692-0.335 1.076-0.349s0.765 0.080 1.099 0.271l2.32 1.338 4.361-7.563-2.32-1.338c-0.331-0.194-0.601-0.476-0.78-0.815s-0.261-0.721-0.235-1.104c0-0.212 0-0.435 0-0.647s0-0.435 0-0.647c-0.026-0.383 0.056-0.765 0.235-1.104s0.449-0.621 0.78-0.815l2.409-1.316zM22.643 15.326c0 1.414-0.419 2.797-1.205 3.972s-1.902 2.092-3.209 2.633c-1.306 0.541-2.744 0.683-4.131 0.407s-2.661-0.957-3.661-1.957-1.681-2.274-1.957-3.661c-0.276-1.387-0.134-2.825 0.407-4.131s1.458-2.423 2.633-3.209c1.176-0.786 2.558-1.205 3.972-1.205 1.896 0 3.715 0.753 5.056 2.094s2.094 3.159 2.094 5.056z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-dark-gear",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#52555f",
    style: {
      fill: "var(--color2, #52555f)"
    },
    d: "M27.875 18.356c0.586-2.412 0.444-4.944-0.408-7.275s-2.377-4.358-4.381-5.823c-2.004-1.465-4.397-2.303-6.877-2.408s-4.936 0.527-7.056 1.818-3.811 3.18-4.858 5.431c-1.047 2.251-1.402 4.762-1.022 7.215s1.479 4.738 3.157 6.567c1.679 1.829 3.862 3.119 6.273 3.707 3.236 0.786 6.652 0.256 9.497-1.475s4.886-4.521 5.675-7.756zM21.369 16.769c-0.276 1.129-0.881 2.151-1.739 2.935s-1.929 1.297-3.078 1.471c-1.149 0.175-2.324 0.004-3.376-0.49s-1.934-1.29-2.533-2.286c-0.599-0.996-0.889-2.148-0.832-3.309s0.456-2.279 1.149-3.212c0.693-0.933 1.647-1.64 2.742-2.030s2.281-0.446 3.408-0.161c1.503 0.373 2.798 1.326 3.6 2.651s1.047 2.914 0.68 4.419l-0.021 0.011z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52555f",
    style: {
      fill: "var(--color2, #52555f)"
    },
    d: "M15.194 27.64l-4.695-1.139-0.543 3.386 4.163 1.012 1.075-3.258z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52555f",
    style: {
      fill: "var(--color2, #52555f)"
    },
    d: "M6.644 23.882l-2.513-4.121-2.779 2.002 2.236 3.673 3.056-1.554z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52555f",
    style: {
      fill: "var(--color2, #52555f)"
    },
    d: "M3.258 15.183l1.139-4.685-3.375-0.554-1.022 4.174 3.258 1.065z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52555f",
    style: {
      fill: "var(--color2, #52555f)"
    },
    d: "M7.017 6.644l4.12-2.513-2.002-2.779-3.663 2.236 1.544 3.056z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52555f",
    style: {
      fill: "var(--color2, #52555f)"
    },
    d: "M15.715 3.258l4.695 1.139 0.543-3.386-4.174-1.012-1.065 3.258z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52555f",
    style: {
      fill: "var(--color2, #52555f)"
    },
    d: "M24.265 7.016l2.502 4.121 2.79-2.002-2.236-3.673-3.056 1.554z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52555f",
    style: {
      fill: "var(--color2, #52555f)"
    },
    d: "M27.651 15.715l-1.15 4.685 3.386 0.554 1.022-4.174-3.258-1.065z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52555f",
    style: {
      fill: "var(--color2, #52555f)"
    },
    d: "M23.892 24.255l-4.131 2.513 2.012 2.779 3.663-2.225-1.544-3.066z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52555f",
    style: {
      fill: "var(--color2, #52555f)"
    },
    d: "M11.787 17.685l3.769 2.055 3.663-2.236-0.096-4.259-3.769-2.066-3.663 2.225 0.096 4.28zM15.78 14.097c0.262 0.064 0.498 0.205 0.68 0.404s0.3 0.447 0.341 0.713 0.002 0.539-0.112 0.783c-0.114 0.244-0.298 0.449-0.528 0.589s-0.497 0.208-0.766 0.196c-0.269-0.012-0.529-0.103-0.746-0.262s-0.383-0.379-0.475-0.632-0.108-0.528-0.044-0.79c0.088-0.35 0.311-0.652 0.62-0.839s0.679-0.245 1.031-0.162z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-red-cross",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ff1717",
    style: {
      fill: "var(--color1, #ff1717)"
    },
    d: "M16 2.667c-7.373 0-13.333 5.96-13.333 13.333s5.96 13.333 13.333 13.333c7.373 0 13.333-5.96 13.333-13.333s-5.96-13.333-13.333-13.333zM16 26.667c-5.88 0-10.667-4.787-10.667-10.667s4.787-10.667 10.667-10.667c5.88 0 10.667 4.787 10.667 10.667s-4.787 10.667-10.667 10.667zM20.787 9.333l-4.787 4.787-4.787-4.787-1.88 1.88 4.787 4.787-4.787 4.787 1.88 1.88 4.787-4.787 4.787 4.787 1.88-1.88-4.787-4.787 4.787-4.787-1.88-1.88z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-green-check",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#01ab3a",
    style: {
      fill: "var(--color2, #01ab3a)"
    },
    d: "M29.333 6.907l-15.213 15.227-5.653-5.653 1.88-1.88 3.773 3.773 13.333-13.333 1.88 1.867zM26.387 13.627c0.173 0.76 0.28 1.56 0.28 2.373 0 5.893-4.773 10.667-10.667 10.667s-10.667-4.773-10.667-10.667c0-5.893 4.773-10.667 10.667-10.667 2.107 0 4.053 0.613 5.707 1.667l1.92-1.92c-2.16-1.52-4.787-2.413-7.627-2.413-7.36 0-13.333 5.973-13.333 13.333s5.973 13.333 13.333 13.333c7.36 0 13.333-5.973 13.333-13.333 0-1.587-0.293-3.107-0.8-4.52l-2.147 2.147z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-I-owe",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ff1717",
    style: {
      fill: "var(--color1, #ff1717)"
    },
    d: "M0 4v10.667h14.667v-14.667h-10.667c-1.061 0-2.078 0.421-2.828 1.172s-1.172 1.768-1.172 2.828v0zM12 12h-9.333v-8c0-0.354 0.14-0.693 0.391-0.943s0.589-0.391 0.943-0.391h8v9.333z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff1717",
    style: {
      fill: "var(--color1, #ff1717)"
    },
    d: "M0 28c0 1.061 0.421 2.078 1.172 2.828s1.768 1.172 2.828 1.172h10.667v-14.667h-14.667v10.667zM2.667 20h9.333v9.333h-8c-0.354 0-0.693-0.141-0.943-0.391s-0.391-0.589-0.391-0.943v-8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff1717",
    style: {
      fill: "var(--color1, #ff1717)"
    },
    d: "M17.333 17.333v14.667h10.667c1.061 0 2.078-0.421 2.828-1.172s1.172-1.768 1.172-2.828v-10.667h-14.667zM29.333 28c0 0.354-0.141 0.693-0.391 0.943s-0.589 0.391-0.943 0.391h-8v-9.333h9.333v8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff1717",
    style: {
      fill: "var(--color1, #ff1717)"
    },
    d: "M30.667 6.667h-13.333v2.667h13.333v-2.667z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-Im-owed",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#01ab3a",
    style: {
      fill: "var(--color2, #01ab3a)"
    },
    d: "M0 4v10.667h14.667v-14.667h-10.667c-1.061 0-2.078 0.421-2.828 1.172s-1.172 1.768-1.172 2.828v0zM12 12h-9.333v-8c0-0.354 0.14-0.693 0.391-0.943s0.589-0.391 0.943-0.391h8v9.333z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#01ab3a",
    style: {
      fill: "var(--color2, #01ab3a)"
    },
    d: "M0 28c0 1.061 0.421 2.078 1.172 2.828s1.768 1.172 2.828 1.172h10.667v-14.667h-14.667v10.667zM2.667 20h9.333v9.333h-8c-0.354 0-0.693-0.141-0.943-0.391s-0.391-0.589-0.391-0.943v-8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#01ab3a",
    style: {
      fill: "var(--color2, #01ab3a)"
    },
    d: "M17.333 17.333v14.667h10.667c1.061 0 2.078-0.421 2.828-1.172s1.172-1.768 1.172-2.828v-10.667h-14.667zM29.333 28c0 0.354-0.141 0.693-0.391 0.943s-0.589 0.391-0.943 0.391h-8v-9.333h9.333v8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#01ab3a",
    style: {
      fill: "var(--color2, #01ab3a)"
    },
    d: "M22.667 14.667h2.667v-5.333h5.333v-2.667h-5.333v-5.333h-2.667v5.333h-5.333v2.667h5.333v5.333z"
  })), _symbol10 || (_symbol10 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-arrow-left",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.124 24.742l1.829-1.885-6.856-7.057 6.856-7.057-1.834-1.885-6.851 7.057c-0.486 0.5-0.759 1.178-0.759 1.885s0.273 1.385 0.759 1.885l6.856 7.057z"
  }))), _symbol11 || (_symbol11 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-arrow-right",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.876 24.742l-1.829-1.885 6.856-7.057-6.856-7.057 1.834-1.885 6.851 7.057c0.486 0.5 0.759 1.178 0.759 1.885s-0.273 1.385-0.759 1.885l-6.856 7.057z"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-big-arrow-right",
    viewBox: "0 0 37 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ff7601",
    style: {
      fill: "var(--color1, #ff7601)"
    },
    d: "M34.569 11.152l-10.482-10.482-3.232 3.232 9.742 9.744-30.597 0.069v4.503h30.734l-9.881 9.881 3.232 3.232 10.485-10.482c1.282-1.288 2.001-3.031 2.001-4.848s-0.72-3.56-2.001-4.848z"
  })), _symbol12 || (_symbol12 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-calendar",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28 2.667h-4v-2.667h-2.667v2.667h-10.667v-2.667h-2.667v2.667h-4c-1.061 0-2.078 0.421-2.828 1.172s-1.172 1.768-1.172 2.828v25.333h32v-25.333c0-1.061-0.421-2.078-1.172-2.828s-1.767-1.172-2.828-1.172zM2.667 6.667c0-0.354 0.14-0.693 0.391-0.943s0.589-0.391 0.943-0.391h24c0.354 0 0.693 0.14 0.943 0.391s0.391 0.589 0.391 0.943v4h-26.667v-4zM2.667 29.333v-16h26.667v16h-26.667z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.667 17.333h-2.667v2.667h2.667v-2.667z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.334 17.333h-2.667v2.667h2.667v-2.667z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 17.333h-2.667v2.667h2.667v-2.667z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.667 22.667h-2.667v2.667h2.667v-2.667z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.334 22.667h-2.667v2.667h2.667v-2.667z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 22.667h-2.667v2.667h2.667v-2.667z"
  }))), _symbol13 || (_symbol13 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-successfully-checked",
    viewBox: "0 0 12 12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 2.59 5.295 8.3l-2.12-2.12.705-.705L5.295 6.89l5-5 .705.7ZM9.895 5.11c.065.285.105.585.105.89 0 2.21-1.79 4-4 4S2 8.21 2 6s1.79-4 4-4c.79 0 1.52.23 2.14.625l.72-.72A4.95 4.95 0 0 0 6 1C3.24 1 1 3.24 1 6s2.24 5 5 5 5-2.24 5-5c0-.595-.11-1.165-.3-1.695l-.805.805Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h12v12H0z"
  }))), _symbol14 || (_symbol14 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-failed-checked",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 1C3.235 1 1 3.235 1 6s2.235 5 5 5 5-2.235 5-5-2.235-5-5-5Zm0 9c-2.205 0-4-1.795-4-4s1.795-4 4-4 4 1.795 4 4-1.795 4-4 4Zm1.795-6.5L6 5.295 4.205 3.5l-.705.705L5.295 6 3.5 7.795l.705.705L6 6.705 7.795 8.5l.705-.705L6.705 6 8.5 4.205 7.795 3.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h12v12H0z"
  }))), _symbol15 || (_symbol15 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-calculator",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.25 0h-22.5c-1.551 0-2.813 1.262-2.813 2.813v26.375c0 1.551 1.262 2.812 2.813 2.812h22.5c1.551 0 2.813-1.262 2.813-2.812v-26.375c0-1.551-1.262-2.813-2.813-2.813zM28.188 29.188c0 0.517-0.421 0.937-0.938 0.937h-22.5c-0.517 0-0.938-0.42-0.938-0.937v-26.375c0-0.517 0.421-0.938 0.938-0.938h22.5c0.517 0 0.938 0.421 0.938 0.938v26.375z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.375 3.75h-18.75c-0.518 0-0.938 0.42-0.938 0.938v7.625c0 0.518 0.42 0.938 0.938 0.938h18.75c0.518 0 0.937-0.42 0.937-0.938v-7.625c0-0.518-0.42-0.938-0.937-0.938zM24.437 11.375h-16.875v-5.75h16.875v5.75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.375 15.125h-3.75c-0.518 0-0.938 0.42-0.938 0.938v3.75c0 0.518 0.42 0.938 0.938 0.938h3.75c0.518 0 0.938-0.42 0.938-0.938v-3.75c0-0.518-0.42-0.938-0.938-0.938zM9.438 18.875h-1.875v-1.875h1.875v1.875z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.375 22.625h-3.75c-0.518 0-0.938 0.42-0.938 0.938v3.75c0 0.518 0.42 0.937 0.938 0.937h3.75c0.518 0 0.938-0.42 0.938-0.937v-3.75c0-0.518-0.42-0.938-0.938-0.938zM9.438 26.375h-1.875v-1.875h1.875v1.875z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.875 15.125h-3.75c-0.518 0-0.938 0.42-0.938 0.938v3.75c0 0.518 0.42 0.938 0.938 0.938h3.75c0.518 0 0.937-0.42 0.937-0.938v-3.75c0-0.518-0.42-0.938-0.937-0.938zM16.937 18.875h-1.875v-1.875h1.875v1.875z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.875 22.625h-3.75c-0.518 0-0.938 0.42-0.938 0.938v3.75c0 0.518 0.42 0.937 0.938 0.937h3.75c0.518 0 0.937-0.42 0.937-0.937v-3.75c0-0.518-0.42-0.938-0.937-0.938zM16.937 26.375h-1.875v-1.875h1.875v1.875z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.375 15.125h-3.75c-0.518 0-0.937 0.42-0.937 0.938v11.25c0 0.518 0.42 0.937 0.937 0.937h3.75c0.518 0 0.937-0.42 0.937-0.937v-11.25c0-0.518-0.42-0.938-0.937-0.938zM24.437 26.375h-1.875v-9.375h1.875v9.375z"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-Card",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ff7601",
    style: {
      fill: "var(--color1, #ff7601)"
    },
    d: "M7.333 22.667c1.105 0 2-0.895 2-2s-0.895-2-2-2c-1.105 0-2 0.895-2 2s0.895 2 2 2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff7601",
    style: {
      fill: "var(--color1, #ff7601)"
    },
    d: "M28 4h-24c-1.061 0-2.078 0.421-2.828 1.172s-1.172 1.768-1.172 2.828v20h32v-20c0-1.061-0.421-2.078-1.172-2.828s-1.768-1.172-2.828-1.172zM4 6.667h24c0.354 0 0.693 0.14 0.943 0.391s0.391 0.589 0.391 0.943v2.667h-26.667v-2.667c0-0.354 0.14-0.693 0.391-0.943s0.589-0.391 0.943-0.391zM2.667 25.333v-12h26.667v12h-26.667z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-Cash",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ff7601",
    style: {
      fill: "var(--color1, #ff7601)"
    },
    d: "M16.485 20.485c-1.212 0-2.242-0.424-3.091-1.273s-1.273-1.879-1.273-3.091 0.424-2.242 1.273-3.091c0.848-0.848 1.879-1.273 3.091-1.273s2.243 0.424 3.091 1.273c0.849 0.848 1.273 1.879 1.273 3.091s-0.424 2.242-1.273 3.091c-0.848 0.849-1.879 1.273-3.091 1.273zM4.848 25.576c-0.6 0-1.114-0.214-1.541-0.641s-0.641-0.941-0.641-1.541v-14.546c0-0.6 0.214-1.114 0.641-1.541s0.941-0.641 1.541-0.641h23.273c0.6 0 1.114 0.214 1.541 0.641s0.641 0.941 0.641 1.541v14.546c0 0.6-0.214 1.114-0.641 1.541s-0.941 0.641-1.541 0.641h-23.273zM8.485 23.394h16c0-1.018 0.352-1.879 1.055-2.582s1.564-1.055 2.582-1.055v-7.273c-1.018 0-1.879-0.352-2.582-1.055s-1.055-1.564-1.055-2.582h-16c0 1.018-0.352 1.879-1.055 2.582s-1.564 1.055-2.582 1.055v7.273c1.018 0 1.879 0.351 2.582 1.055s1.055 1.564 1.055 2.582z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-fi-rs-apps-add",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#01ab3a",
    style: {
      fill: "var(--color1, #01ab3a)"
    },
    d: "M0 4v10.667h14.667v-14.667h-10.667c-1.061 0-2.078 0.421-2.828 1.172s-1.172 1.768-1.172 2.828v0zM12 12h-9.333v-8c0-0.354 0.14-0.693 0.391-0.943s0.589-0.391 0.943-0.391h8v9.333z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#01ab3a",
    style: {
      fill: "var(--color1, #01ab3a)"
    },
    d: "M0 28c0 1.061 0.421 2.078 1.172 2.828s1.768 1.172 2.828 1.172h10.667v-14.667h-14.667v10.667zM2.667 20h9.333v9.333h-8c-0.354 0-0.693-0.141-0.943-0.391s-0.391-0.589-0.391-0.943v-8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#01ab3a",
    style: {
      fill: "var(--color1, #01ab3a)"
    },
    d: "M17.333 17.333v14.667h10.667c1.061 0 2.078-0.421 2.828-1.172s1.172-1.768 1.172-2.828v-10.667h-14.667zM29.333 28c0 0.354-0.141 0.693-0.391 0.943s-0.589 0.391-0.943 0.391h-8v-9.333h9.333v8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#01ab3a",
    style: {
      fill: "var(--color1, #01ab3a)"
    },
    d: "M22.667 14.667h2.667v-5.333h5.333v-2.667h-5.333v-5.333h-2.667v5.333h-5.333v2.667h5.333v5.333z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-fi-rs-apps-delete",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ff1717",
    style: {
      fill: "var(--color2, #ff1717)"
    },
    d: "M0 4v10.667h14.667v-14.667h-10.667c-1.061 0-2.078 0.421-2.828 1.172s-1.172 1.768-1.172 2.828v0zM12 12h-9.333v-8c0-0.354 0.14-0.693 0.391-0.943s0.589-0.391 0.943-0.391h8v9.333z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff1717",
    style: {
      fill: "var(--color2, #ff1717)"
    },
    d: "M0 28c0 1.061 0.421 2.078 1.172 2.828s1.768 1.172 2.828 1.172h10.667v-14.667h-14.667v10.667zM2.667 20h9.333v9.333h-8c-0.354 0-0.693-0.141-0.943-0.391s-0.391-0.589-0.391-0.943v-8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff1717",
    style: {
      fill: "var(--color2, #ff1717)"
    },
    d: "M17.333 17.333v14.667h10.667c1.061 0 2.078-0.421 2.828-1.172s1.172-1.768 1.172-2.828v-10.667h-14.667zM29.333 28c0 0.354-0.141 0.693-0.391 0.943s-0.589 0.391-0.943 0.391h-8v-9.333h9.333v8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff1717",
    style: {
      fill: "var(--color2, #ff1717)"
    },
    d: "M30.667 6.667h-13.333v2.667h13.333v-2.667z"
  })), _symbol16 || (_symbol16 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-privat",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.333 22.667c1.105 0 2-0.895 2-2s-0.895-2-2-2c-1.105 0-2 0.895-2 2s0.895 2 2 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 4h-24c-1.061 0-2.078 0.421-2.828 1.172s-1.172 1.768-1.172 2.828v20h32v-20c0-1.061-0.421-2.078-1.172-2.828s-1.768-1.172-2.828-1.172zM4 6.667h24c0.354 0 0.693 0.14 0.943 0.391s0.391 0.589 0.391 0.943v2.667h-26.667v-2.667c0-0.354 0.14-0.693 0.391-0.943s0.589-0.391 0.943-0.391zM2.667 25.333v-12h26.667v12h-26.667z"
  }))), _symbol17 || (_symbol17 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-info",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("text", {
    x: "50%",
    y: "50%",
    fill: "#FF7601",
    fontSize: 32,
    fontFamily: "Verdana",
    fontWeight: "bold",
    textAnchor: "middle",
    alignmentBaseline: "central"
  }, "i"))), _symbol18 || (_symbol18 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-pay",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("text", {
    x: "50%",
    y: "50%",
    fill: "#4CAF50",
    fontWeight: "bold",
    fontSize: 32,
    fontFamily: "Arial",
    textAnchor: "middle",
    alignmentBaseline: "central"
  }, "+"))), _symbol19 || (_symbol19 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-skip",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 15,
    width: 24,
    height: 4,
    fill: "red"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-null",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 15,
    fill: "transparent",
    stroke: "#FF7601",
    style: {
      stroke: "var(--color1, #FF7601)"
    },
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 15,
    width: 16,
    height: 3,
    fill: "#FF7601",
    style: {
      fill: "var(--color1, #FF7601)"
    }
  })), _symbol20 || (_symbol20 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-empty",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 15,
    fill: "transparent",
    stroke: "currentColor",
    strokeWidth: 2
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllSvgFinTrack);
export default __webpack_public_path__ + "static/media/allSvgFinTrack.278330725f6d287af2f110c6ffc5731c.svg";
export { ForwardRef as ReactComponent };